export const lightTheme = {
    body: "rgb(238, 238, 242)",
    secondaryBody: "rgb(240,240,240)",
    text: "#000000",
    secondText: "rgb(78, 78, 78)",
    toggleBorder: "#1A202C",
    secondBackgroundColor: "#fff",
    filter: "invert(1) grayscale(100%) brightness(10%)"
  };
  
  export const darkTheme = {
    body: "rgb(26, 32, 44)",
    secondaryBody: "rgb(38,43,73)",
    text: "#FFFFFF",
    secondText: "rgb(189, 180, 180)",
    toggleBorder: "#6B8096",
    secondBackgroundColor: "#fff",
    filter: "invert(1) grayscale(100%) brightness(100%)"
  };